(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-quote-form"] && !Shopify.designMode) return;
  try {
    
  class CustomQuoteContext extends HTMLElement {
    connectedCallback() {
      this.params = new URLSearchParams(window.location.search);
      this.contextValue = this.querySelector('[data-custom-quote-context-value]');
      this.appShell = this.querySelector('[data-custom-quote-app-shell]');
      this.appSuccess = this.querySelector('[data-custom-quote-app-success]');
      this.productSelect = this.querySelector('[data-custom-quote-product]');
      this.otherField = this.querySelector('[data-custom-quote-other-field]');
      this.otherInput = this.querySelector('[data-custom-quote-other-input]');
      this.selectedTitleInput = this.querySelector('[data-custom-quote-selected-title]');
      this.selectedHandleInput = this.querySelector('[data-custom-quote-selected-handle]');
      this.selectedUrlInput = this.querySelector('[data-custom-quote-selected-url]');
      this.productName = this.params.get('product_name')?.trim() || '';
      this.isProductReferral = this.params.get('source') === 'product_page' && Boolean(this.productName);

      this.productSelect?.addEventListener('change', this.handleProductChange);
      this.otherInput?.addEventListener('input', this.handleOtherInput);

      const requestedHandle = this.params.get('product')?.trim() || '';
      if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(requestedHandle)) {
        const matchingOption = Array.from(this.productSelect?.options || []).find(
          (option) => option.value === requestedHandle
        );
        if (matchingOption) this.productSelect.value = requestedHandle;
      }

      this.updateProductSelection();

      if (this.isProductReferral && this.contextValue) {
        this.contextValue.value = `${this.dataset.productPrefix} ${this.productName}`;
      }

      if (this.appShell) this.waitForForm(Date.now() + 20000);
    }

    disconnectedCallback() {
      this.productSelect?.removeEventListener('change', this.handleProductChange);
      this.otherInput?.removeEventListener('input', this.handleOtherInput);
      this.appForm?.removeEventListener('submit', this.handleAppSubmit, true);
      this.appLeadCapture?.removeEventListener('complete', this.showAppSuccess);
      this.successObserver?.disconnect();
    }

    handleProductChange = () => {
      this.updateProductSelection();
    };

    handleOtherInput = () => {
      this.syncAppProductField();
    };

    handleAppSubmit = (event) => {
      if (this.productSelect?.value !== '__other__' || this.otherInput?.value.trim()) return;
      event.preventDefault();
      this.otherInput?.reportValidity();
      this.otherInput?.focus();
    };

    watchForAppSuccess(root) {
      this.appLeadCapture = root.querySelector('shop-lead-capture');
      this.appLeadCapture?.addEventListener('complete', this.showAppSuccess);
      this.successObserver = new MutationObserver(() => {
        if (!root.querySelector('form') || !root.querySelector('button[type="submit"]')) this.showAppSuccess();
      });
      this.successObserver.observe(root, { childList: true, subtree: true });
    }

    showAppSuccess = () => {
      if (!this.appSuccess) return;
      this.successObserver?.disconnect();
      this.appShell?.classList.add('is-complete');
      this.appSuccess.hidden = false;
    };

    waitForForm(deadline) {
      const embed = this.querySelector('shopify-forms-embed');
      const form = embed?.shadowRoot?.querySelector('form');

      if (form) {
        this.appShell?.classList.add('is-ready');
        this.appShell?.setAttribute('aria-busy', 'false');
        if (this.isProductReferral) this.prefillForm(embed.shadowRoot);
        this.appForm = form;
        this.appProductField = embed.shadowRoot.getElementById('custom#bag_type');
        const appProductLabel = embed.shadowRoot.getElementById('label-custom#bag_type');
        if (appProductLabel) appProductLabel.textContent = this.dataset.productSelectLabel;
        if (this.appProductField?.parentElement) this.appProductField.parentElement.style.display = 'none';
        this.appForm.addEventListener('submit', this.handleAppSubmit, true);
        this.watchForAppSuccess(embed.shadowRoot);
        this.syncAppProductField();
        return;
      }

      if (Date.now() < deadline) {
        window.setTimeout(() => this.waitForForm(deadline), 50);
      }
    }

    prefillForm(root) {
      const selectedOptions = this.params.get('selected_options')?.trim() || '';
      const customFields = this.params.get('custom_fields')?.trim() || '';
      const sizeAndStyle = [selectedOptions, customFields].filter(Boolean).join(' | ');
      const productUrl = this.params.get('product_url')?.trim() || '';
      const sourcePage = this.params.get('source_page')?.trim() || productUrl;
      const sku = this.params.get('sku')?.trim() || '';
      const material = this.params.get('material')?.trim() || '';
      const contextLines = [
        this.dataset.contextHeading,
        `${this.dataset.productLabel}: ${this.productName}`,
        productUrl ? `${this.dataset.urlLabel}: ${productUrl}` : '',
        sizeAndStyle ? `${this.dataset.optionsLabel}: ${sizeAndStyle}` : '',
        sku ? `${this.dataset.skuLabel}: ${sku}` : '',
        sourcePage ? `${this.dataset.sourceLabel}: ${sourcePage}` : '',
      ].filter(Boolean);

      this.setFieldValue(root.getElementById('custom#size'), sizeAndStyle);
      this.setFieldValue(root.getElementById('custom#material'), material);
      this.setFieldValue(root.querySelector('textarea[name="custom#printing"]'), `${contextLines.join('\n')}\n\n`);
    }

    updateProductSelection() {
      const option = this.productSelect?.selectedOptions?.[0];
      const isOther = option?.value === '__other__';
      const handle = option?.value && !isOther ? option.value : '';
      const title = handle ? option.textContent.trim() : '';
      const productUrl = handle ? new URL(`/products/${encodeURIComponent(handle)}`, window.location.origin).toString() : '';

      if (this.otherField) this.otherField.hidden = !isOther;
      if (this.otherInput) {
        this.otherInput.disabled = !isOther;
        this.otherInput.required = isOther;
        if (!isOther) this.otherInput.value = '';
      }

      if (this.selectedTitleInput) this.selectedTitleInput.value = title;
      if (this.selectedHandleInput) this.selectedHandleInput.value = handle;
      if (this.selectedUrlInput) this.selectedUrlInput.value = productUrl;
      this.syncAppProductField();
    }

    syncAppProductField() {
      if (!this.appProductField) return;

      const option = this.productSelect?.selectedOptions?.[0];
      const isOther = option?.value === '__other__';
      const handle = option?.value && !isOther ? option.value : '';
      const title = handle ? option.textContent.trim() : '';
      const productUrl = handle ? new URL(`/products/${encodeURIComponent(handle)}`, window.location.origin).toString() : '';
      const otherDescription = this.otherInput?.value.trim() || '';
      const value = isOther
        ? otherDescription ? `Other Product Description: ${otherDescription}` : ''
        : handle ? `Selected Product Title: ${title} | Selected Product Handle: ${handle} | Selected Product URL: ${productUrl}` : '';

      this.setFieldValue(this.appProductField, value, true);
    }

    setFieldValue(field, value, overwrite = false) {
      if (!field || (!overwrite && (!value || field.value))) return;
      const prototype = field instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
      setter?.call(field, value);
      field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }
  }

  if (!customElements.get('custom-quote-context')) {
    customElements.define('custom-quote-context', CustomQuoteContext);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
